import FeeTab from './FeeTab.vue';

export default FeeTab;
